import {
  GET_PREMIUM_AGE_BAND,
  GET_PREMIUM_PRICE_LIST,
  GET_PREMIUM_PRODUCTS,
} from '../utils/Endpoints'

import axios from 'axios'

export const getProducts = async () => {
  try {
    const response: any = await axios.get(
      `${process.env.REACT_APP_ODOO_COGNITIVECARE}${GET_PREMIUM_PRODUCTS}`
    )

    if (response?.data?.length > 0) {
      return {
        success: true,
        data: response?.data,
        message: 'Success',
      }
    } else {
      return {
        success: false,
        data: null,
        message: 'Failed',
      }
    }
  } catch (error: any) {
    // console.error('Error opening file: ', error)
    return {
      success: false,
      data: null,
      message: error?.message,
    }
  }
}

export const getAgeBand = async () => {
  try {
    const response: any = await axios.get(
      `${process.env.REACT_APP_ODOO_COGNITIVECARE}${GET_PREMIUM_AGE_BAND}`
    )
    if (response?.data) {
      return {
        success: true,
        data: response?.data,
        message: 'Success',
      }
    } else {
      return {
        success: false,
        data: null,
        message: 'Failed',
      }
    }
  } catch (error: any) {
    // console.error('Error opening file: ', error)
    return {
      success: false,
      data: null,
      message: error?.message,
    }
  }
}

export const getPriceList = async (
  productId: number | null,
  ageBand: string,
  type: string,
  adult: number | null,
  child: number | null
) => {
  try {
    const response: any = await axios.get(
      `${process.env.REACT_APP_ODOO_COGNITIVECARE}${GET_PREMIUM_PRICE_LIST}?product_id=${productId}&age_band=${ageBand}&type=${type}&adult=${adult}&child=${child}`
    )
    if (response?.data) {
      return {
        success: true,
        data: response?.data?.price_list_items?.[0],
        message: 'Success',
      }
    } else {
      return {
        success: false,
        data: null,
        message: 'Failed',
      }
    }
  } catch (error: any) {
    // console.error('Error opening file: ', error)
    return {
      success: false,
      data: null,
      message: error?.message,
    }
  }
}
